import React, { useMemo } from 'react';
import { injectIntl } from 'react-intl';
import enTranslation from '../translations/en';

const prefix = `app.commonUtils.capUiLibrary`;

const LocaleHoc = (WrapperComponent, customProps) => {
  const Wrapper = (props) => {
    const componentName = customProps.key;
    const translatedDefaults = enTranslation[customProps.key];
    const { intl } = props;

    const translatedProps = useMemo(() => {
      if(!translatedDefaults) return {};
      return Object.keys(translatedDefaults).reduce((acc, key) => {
        const id = `${prefix}.${componentName}.${key}`
        const defaultMessage = translatedDefaults[key]
        try{
          acc[key] = intl.formatMessage({ id, defaultMessage });
        }catch(err){
          acc[key] = defaultMessage;
        }
        return acc;
      }, {});
    }, [translatedDefaults, intl]);

    return (
      <WrapperComponent
        {...translatedProps}
        {...props}
      />
    );
  }

  return injectIntl(Wrapper);
};

export default LocaleHoc;